module.exports = __webpack_public_path__ + "img/D1_HQ.96f97274.jpg";